import { z } from 'zod'
import { AsyncFn } from '../../common'
import { guidSchema } from '../../contracts/_common'
import type { ForCompany } from '../Company/Company'
import type { Guid } from '../common-schemas'
import { PricebookItemTypeSchema } from './PricebookTypes'

export const ServiceBundleItemQuantitySchema = z.number().int().min(1)

export const ServiceBundleItemInputSchema = z.object({
  childPricebookItemGuid: guidSchema,
  itemQuantity: ServiceBundleItemQuantitySchema,
})

export type ServiceBundleItemInput = z.infer<typeof ServiceBundleItemInputSchema>

export const ServiceBundleItemSchema = ServiceBundleItemInputSchema.extend({
  itemType: PricebookItemTypeSchema,
})

export type ServiceBundleItem = z.infer<typeof ServiceBundleItemSchema>

export const ServiceBundleSchema = z.object({
  items: z.array(ServiceBundleItemSchema),
  serviceTimeMinutes: z.number().int().nonnegative(),
})

export type ServiceBundle = z.infer<typeof ServiceBundleSchema>

export const GetServiceBundleRequestSchema = z.object({
  companyGuid: guidSchema,
  parentPricebookItemGuid: guidSchema,
})

export const SaveServiceBundleRequestSchema = z.object({
  companyGuid: guidSchema,
  parentPricebookItemGuid: guidSchema,
  items: z.array(ServiceBundleItemInputSchema),
})

export const ListParentServicesForConstituentRequestSchema = z.object({
  companyGuid: guidSchema,
  childPricebookItemGuid: guidSchema,
})

export const ParentServiceReferenceSchema = z.object({
  parentPricebookItemGuid: guidSchema,
  parentServiceName: z.string(),
})

export type ParentServiceReference = z.infer<typeof ParentServiceReferenceSchema>

export const UnlinkConstituentFromAllServicesRequestSchema = z.object({
  companyGuid: guidSchema,
  childPricebookItemGuid: guidSchema,
})

export type ServiceBundleReader = AsyncFn<ForCompany<{ parentPricebookItemGuid: Guid }>, ServiceBundle>

export type ServiceBundleWriter = AsyncFn<
  ForCompany<{ parentPricebookItemGuid: Guid; items: ServiceBundleItemInput[] }>,
  void
>

export type ParentServicesForConstituentReader = AsyncFn<
  ForCompany<{ childPricebookItemGuid: Guid }>,
  ParentServiceReference[]
>

export type ConstituentUnlinker = AsyncFn<ForCompany<{ childPricebookItemGuid: Guid }>, void>
